import { createSlice } from '@reduxjs/toolkit';
import { fetchAllUserCount, getConversationAnalytics, PieChart } from './chartThunk';

const chartSlice = createSlice(
    {
        name: 'chart',
        initialState: {
            PieChartLodading: null,
            PieChartError: null,
            PieChartFullfill: null,

            loading: null,
            error: null,
            allUserCount: null,
        },
        reducers: {

        },
        extraReducers: (builder) => {
            builder

                .addCase(PieChart.pending, (state) => {
                    state.PieChartLodading = true;
                })
                .addCase(PieChart.fulfilled, (state, action) => {
                    state.PieChartLodading = false;
                    state.PieChartFullfill = action.payload
                })
                .addCase(PieChart.rejected, (state, action) => {
                    state.PieChartLodading = false;
                    state.PieChartError = action.payload;
                })

                .addCase(fetchAllUserCount.pending, (state) => {
                    state.loading = true;
                    state.error = null;
                })
                .addCase(fetchAllUserCount.fulfilled, (state, action) => {
                    state.allUserCount = action.payload;
                    state.loading = false;
                })
                .addCase(fetchAllUserCount.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                })

                .addCase(getConversationAnalytics.pending, (state) => {
                    state.loading = true;
                    state.error = null;
                })
                .addCase(getConversationAnalytics.fulfilled, (state, action) => {
                    state.loading = false;
                    state.analyticsData = action.payload;
                })
                .addCase(getConversationAnalytics.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                });
        }
    }
)
export default chartSlice.reducer;
